import { useQueries, useQuery } from '@tanstack/react-query';

import { CerberusApi } from '@hcs/cerberus';
import {
  MsaListingStatsTimeSeriesDocument,
  MsaListingStatsTimeSeriesQuery,
  MsaListingStatsTimeSeriesQueryVariables,
} from '@hcs/types';

import { msaListingStatsTSToCerberusListingStats } from '../utils/cerberus-stats.utils';

const QUERY_KEY_MSA_LISTING_STATS_TIME_SERIES = 'msa-listing-stats-time-series';

export const useMsaListingStatsTimeSeries = ({
  msaId,
  fromDate,
  toDate,
  enabled = true,
}: MsaListingStatsTimeSeriesQueryVariables & {
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: [
      QUERY_KEY_MSA_LISTING_STATS_TIME_SERIES,
      msaId,
      fromDate,
      toDate,
    ],

    queryFn: async () => {
      const response = await CerberusApi.fetchQuery<
        MsaListingStatsTimeSeriesQuery,
        MsaListingStatsTimeSeriesQueryVariables
      >(MsaListingStatsTimeSeriesDocument, {
        msaId,
        fromDate,
        toDate,
      });
      return msaListingStatsTSToCerberusListingStats(response);
    },

    enabled,
  });
};

export const useMultipleMsaListingStatsTimeSeries = ({
  msaIds,
  fromDate,
  toDate,
}: {
  msaIds: Array<MsaListingStatsTimeSeriesQueryVariables['msaId']>;
  fromDate: MsaListingStatsTimeSeriesQueryVariables['fromDate'];
  toDate: MsaListingStatsTimeSeriesQueryVariables['toDate'];
}) => {
  return useQueries({
    queries: msaIds.map((msaId) => {
      return {
        queryKey: [
          QUERY_KEY_MSA_LISTING_STATS_TIME_SERIES,
          msaId,
          fromDate,
          toDate,
        ],
        queryFn: async () => {
          const response = await CerberusApi.fetchQuery<
            MsaListingStatsTimeSeriesQuery,
            MsaListingStatsTimeSeriesQueryVariables
          >(MsaListingStatsTimeSeriesDocument, {
            msaId,
            fromDate,
            toDate,
          });
          return msaListingStatsTSToCerberusListingStats(response);
        },
      };
    }),
  });
};
